






























































import utils from "@/app/shared/utils/utils.js";

export default {
  name: "BaseRangeSlider",
  mixins: [utils],
  data: function () {
    return {
      isGrabbing: false,
      timeBeforeGrabbing: 0,
      collectedMovementX: 0,
      isShowModal: false,
      isActive: false,
      localValue: [0, 0],
      progress: 0,
      roundedProgress: 0,
      playhead: null,
      isFirstTooltipActive: false,
      isSecondTooltipActive: false,
    };
  },
  props: {
    firstValue: {
      type: Number,
    },
    secondValue: {
      type: Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    speed: {
      type: Number,
      default: 1,
    },
    step: {
      type: Number,
      default: 1,
    },
    needDisplayTooltip: {
      type: Boolean,
      default: false,
    },
    needFormatToDate: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.localValue = [this.firstValue, this.secondValue];
  },
  watch: {
    firstValue: function () {
      this.localValue = [this.firstValue, this.secondValue];
    },
    secondValue: function () {
      this.localValue = [this.firstValue, this.secondValue];
    },
  },
  computed: {
    firstPlayhead: function () {
      const percentFromLeft =
        ((this.localValue[0] - this.min) * 100) / (this.max - this.min);
      return percentFromLeft < 0
        ? percentFromLeft
        : percentFromLeft > 100
        ? 100
        : percentFromLeft;
    },
    secondPlayhead: function () {
      const percentFromLeft =
        ((this.localValue[1] - this.min) * 100) / (this.max - this.min);

      return percentFromLeft < 0
        ? percentFromLeft
        : percentFromLeft > 100
        ? 100
        : percentFromLeft;
    },
  },
  mounted() {},
  methods: {
    clickOnProgressBar(event) {
      const fullWidth = event.target.getBoundingClientRect().width;
      const clickWidth = event.offsetX;
      this.progress =
        this.min + ((this.max - this.min) * clickWidth) / fullWidth;
      this.roundedProgress = Math.round(this.progress / this.step) * this.step;

      if (this.progress < this.localValue[0]) {
        this.$emit("change", [this.roundedProgress, this.localValue[1]]);
        this.localValue = [this.roundedProgress, this.localValue[1]];
      } else if (this.progress > this.localValue[1]) {
        this.$emit("change", [this.localValue[0], this.progress]);
        this.localValue = [this.localValue[0], this.progress];
      } else {
        if (
          Math.abs(this.roundedProgress - this.localValue[1]) >
          Math.abs(this.roundedProgress - this.localValue[0])
        ) {
          this.$emit("change", [this.roundedProgress, this.localValue[1]]);
          this.localValue = [this.roundedProgress, this.localValue[1]];
        } else {
          this.$emit("change", [this.localValue[0], this.progress]);
          this.localValue = [this.localValue[0], this.progress];
        }
      }
    },
    startGrab(event) {
      event.stopPropagation();
      this.isGrabbing = true;
      if (event.target === this.$refs.firstPlayhead) {
        this.playhead = "first";
        this.timeBeforeGrabbing = this.localValue[0];
      }
      if (event.target === this.$refs.secondPlayhead) {
        this.timeBeforeGrabbing = this.localValue[1];
        this.playhead = "second";
      }

      window.onmousemove = this.moveCursorAt.bind(event);
      window.onmouseup = this.stopGrab.bind(event);

      this.isActive = true;
    },
    moveCursorAt(event) {
      this.collectedMovementX += event.movementX;
      this.progress =
        this.timeBeforeGrabbing +
        (this.collectedMovementX / this.$refs.player.offsetWidth) *
          (this.max - this.min);
      this.progress =
        this.progress < this.min
          ? this.min
          : this.progress > this.max
          ? this.max
          : this.progress;

      this.roundedProgress = Math.round(this.progress / this.step) * this.step;
      this.roundedProgress =
        this.roundedProgress < this.min
          ? this.min
          : this.roundedProgress > this.max
          ? this.max
          : this.roundedProgress;

      if (this.playhead === "first") {
        this.isFirstTooltipActive = true;
        this.isSecondTooltipActive = false;

        if (this.localValue[1] <= this.progress) {
          this.playhead = "second";
          this.localValue = [this.localValue[1], this.progress];
          this.$emit("change", [this.localValue[1], this.roundedProgress]);
        } else {
          this.localValue = [this.progress, this.localValue[1]];
          this.$emit("change", [this.roundedProgress, this.localValue[1]]);
        }
      }
      if (this.playhead === "second") {
        this.isFirstTooltipActive = false;
        this.isSecondTooltipActive = true;

        if (this.progress <= this.localValue[0]) {
          this.playhead = "first";
          this.localValue = [this.progress, this.localValue[0]];
          this.$emit("change", [this.roundedProgress, this.localValue[0]]);
        } else {
          this.localValue = [this.localValue[0], this.progress];
          this.$emit("change", [this.localValue[0], this.roundedProgress]);
        }
      }
    },
    stopGrab(event) {
      this.isGrabbing = false;
      this.collectedMovementX = 0;
      this.timeBeforeGrabbing = 0;
      this.playhead = null;
      this.isFirstTooltipActive = false;
      this.isSecondTooltipActive = false;

      window.onmouseup = null;
      window.onmousemove = null;

      if (this.playhead === "first") {
        this.localValue = [this.roundedProgress, this.localValue[1]];
      }
      if (this.playhead === "second") {
        this.localValue = [this.localValue[0], this.roundedProgress];
      }
    },
    onMouseOut() {
      if (this.isActive) {
        this.isShowModal = true;
      }
    },
    onMouseUp() {
      if (this.isActive) {
        this.isActive = false;
        this.isShowModal = false;
      }
    },
    displayTooltip(value) {
      if (this.needFormatToDate) {
        return this.convertSecondsToTimeboardStyle(value / this.speed);
      }
      // Возможно будут числовые погрешности языка при step > 1
      // В таком случае добавить условие и при step > 1 возвращать Math.round(value * this.step) / this.step
      return Math.round((value * 1) / this.step) / (1 / this.step);
    },
  },
};
